import React, { useEffect, useState } from 'react'
import PageApp from '../../../Page';
import { HomeOutlined, UnorderedListOutlined, CheckCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import { Table, Empty, Form, Divider, Button, message, Skeleton, Select, Card, Row, Col, Statistic, Space } from 'antd';
import AnioPrenomina from '../../../../components/forms/anio_prenomina';
import FormBody from './form';
import { getEmpleadosActivos } from '../../../../apis/OdooApi';
import { getByEmployeeAndPeriod, recalcularPorEmpleado } from '../../../../apis/OdooAttendanceApi';
import moment from 'moment';

const { Option } = Select;

const routes = [
    {
        href: '',
        title: <>
            <HomeOutlined />
            <span>Inicio</span>
        </>,
    },
    {
        href: '',
        title: (
            <>
                <UnorderedListOutlined />
                <span>Asistencia</span>
            </>
        ),
    },
    {
        href: '',
        title: (
            <>
                <UnorderedListOutlined />
                <span>Procesos</span>
            </>
        ),
    },
    {
        href: '',
        title: (
            <>
                <CheckCircleOutlined />
                <span>Chequeo por Empleado</span>
            </>
        ),
    }
];

const ChequeoEntradasPage = () => {
    const [form] = Form.useForm();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [recalculando, setRecalculando] = useState(false);
    const [period, setPeriod] = useState(null);
    const [anio, setAnio] = useState(null);
    const [empleados, setEmpleados] = useState([]);
    const [empleadoSelected, setEmpleadoSelected] = useState(null);
    const [disabledForm, setDisabled] = useState(true);
    const [totales, setTotales] = useState({
        diasTrabajados: 0,
        horasTrabajadas: 0,
        horasExtras: 0,
        descanso: 0,
        festivos: 0,
        autorizadas: 0
    });

    useEffect(() => {
        (async () => {
            await getCatalogs();
        })();
    }, []);

    useEffect(() => {
        // Calcular totales cuando cambien los items
        calcularTotales();
    }, [items]);

    const getCatalogs = async () => {
        const responseEmpleados = await getEmpleadosActivos({ nomina_need_timesheets: true });
        if (responseEmpleados.ok) {
            let items = responseEmpleados.payload;
            setEmpleados(items);
        }
    }

    const calcularTotales = () => {
        if (items.length === 0) {
            setTotales({
                diasTrabajados: 0,
                horasTrabajadas: 0,
                horasExtras: 0,
                descanso: 0,
                festivos: 0,
                autorizadas: 0
            });
            return;
        }

        const totals = items.reduce((acc, item) => {
            // Contar días trabajados (días con entrada o salida registrada)
            if (item.entrada || item.salida) {
                acc.diasTrabajados += 1;
            }

            acc.horasTrabajadas += parseFloat(item.horas_trabajadas) || 0;
            acc.horasExtras += parseFloat(item.horas_extra) || 0;
            acc.descanso += parseFloat(item.descanso) || 0;
            acc.festivos += parseFloat(item.festivo) || 0;
            acc.autorizadas += parseFloat(item.horas_autorizadas) || 0;

            return acc;
        }, {
            diasTrabajados: 0,
            horasTrabajadas: 0,
            horasExtras: 0,
            descanso: 0,
            festivos: 0,
            autorizadas: 0
        });

        setTotales(totals);
    };

    const columns = [
        {
            title: 'Día',
            dataIndex: 'dia',
            key: 'dia',
            width: 100,
        },
        {
            title: 'Fecha',
            dataIndex: 'fecha',
            key: 'fecha',
            width: 120,
        },
        {
            title: 'Entrada',
            dataIndex: 'entrada',
            key: 'entrada',
            width: 120,
        },
        {
            title: 'Salida',
            dataIndex: 'salida',
            key: 'salida',
            width: 120,
        },
        {
            title: 'Horas Trabajadas',
            dataIndex: 'horas_trabajadas',
            key: 'horas_trabajadas',
            width: 150,
            render: (value) => value || 0
        },
        {
            title: 'Horas Extra',
            dataIndex: 'horas_extra',
            key: 'horas_extra',
            width: 120,
            render: (value) => value || 0
        },
        {
            title: 'Descanso',
            dataIndex: 'descanso',
            key: 'descanso',
            width: 100,
            render: (value) => value || 0
        },
        {
            title: 'Festivo',
            dataIndex: 'festivo',
            key: 'festivo',
            width: 100,
            render: (value) => value || 0
        },
        {
            title: 'Horas Autorizadas',
            dataIndex: 'horas_autorizadas',
            key: 'horas_autorizadas',
            width: 150,
            render: (value) => value || 0
        },
        {
            title: 'Retardo',
            dataIndex: 'retardo',
            key: 'retardo',
            width: 120,
            render: (value) => value || 0
        },
        {
            title: 'Horario',
            dataIndex: 'horario',
            key: 'horario',
            width: 200,
        },
        {
            title: 'Referencia Capturada',
            dataIndex: 'referencia_capturada',
            key: 'referencia_capturada',
            width: 180,
        },
    ];

    const onBlurHeader = async (values, periodData) => {
        if (values?.anio) {
            setAnio(values.anio);
            setPeriod(periodData);
            setDisabled(false);
        } else {
            setAnio(null);
            setPeriod(null);
            setDisabled(true);
            setItems([]);
            setEmpleadoSelected(null);
        }
    }

    const onChangeEmpleado = async (value) => {
        setEmpleadoSelected(value);
        await refreshData(value);
    }

    const refreshData = async (empleadoId) => {
        if (!empleadoId || !period || !anio) {
            setItems([]);
            return;
        }

        setLoading(true);

        try {
            const fechaInicial = moment(period.periodoCompleto.fecha_inicial).format('YYYY-MM-DD');
            const fechaFinal = moment(period.periodoCompleto.fecha_final).format('YYYY-MM-DD');

            const empleadoData = empleados.find(emp => emp.value === empleadoId);

            const response = await getByEmployeeAndPeriod(empleadoId, fechaInicial, fechaFinal);

            if (response.ok) {
                const registrosCompletos = response.payload;

                const dataCompleta = registrosCompletos.map((registro, index) => {
                    const tipoDiaTexto = registro.tipo_dia_texto || 'Hábil';

                    return {
                        key: index,
                        dia: tipoDiaTexto,
                        fecha: moment(registro.fecha).format('DD/MM/YYYY'),
                        entrada: registro.check_in ? moment(registro.check_in).format('HH:mm') : '',
                        salida: registro.check_out ? moment(registro.check_out).format('HH:mm') : '',
                        retardo: registro.retardo || 0,
                        horas_trabajadas: registro.worked_hours || 0,
                        horas_extra: registro.overtime_hours || 0,
                        descanso: registro.descanso || 0, 
                        festivo: registro.festivo || 0, 
                        horas_autorizadas: registro.validated_overtime_hours || 0,
                        estacion: registro.estacion_id ? `Estación ${registro.estacion_id}` : '',
                        horario: empleadoData?.resource_calendar_name || '',
                        referencia_capturada: registro.referencia || '',
                        id: registro.id,
                        odoo_id: registro.odoo_id,
                        empleado_id: empleadoId,
                        estacion_id: registro.estacion_id,
                        horario_id: registro.horario_id,
                        tipo_dia: registro.tipo_dia,
                    };
                });

                setItems(dataCompleta);
            }

        } catch (error) {
            console.error('Error al cargar datos:', error);
            message.error('Error al cargar los datos de asistencia');
        } finally {
            setLoading(false);
        }
    }

    const handleRecalcular = async () => {
        if (!empleadoSelected || !period || !anio) {
            message.warning('Por favor selecciona un empleado y periodo');
            return;
        }

        setRecalculando(true);
        try {
            const fechaInicial = moment(period.periodoCompleto.fecha_inicial).format('YYYY-MM-DD');
            const fechaFinal = moment(period.periodoCompleto.fecha_final).format('YYYY-MM-DD');

            const response = await recalcularPorEmpleado(empleadoSelected, fechaInicial, fechaFinal);

            if (response.ok) {
                message.success(response.message || 'Checadas recalculadas exitosamente');
                // Recargar los datos actualizados
                await refreshData(empleadoSelected);
            } else {
                message.error('Error al recalcular checadas');
            }
        } catch (error) {
            console.error('Error al recalcular:', error);
            message.error('Error al recalcular las checadas');
        } finally {
            setRecalculando(false);
        }
    };

    return <PageApp
        routes={routes}
        title={'Chequeo por Empleado'}>
        <>
            <AnioPrenomina
                onBlur={onBlurHeader}
                form={form}
                disabledForm={false}
            />
            <Divider />

            <Form layout="horizontal" form={form}>
                <Space size="middle" align="start">
                    <Form.Item
                        name="empleado_id"
                        label="Empleado"
                        rules={[
                            {
                                required: true,
                                message: 'Por favor selecciona un empleado',
                            },
                        ]}
                        style={{ width: 400, marginBottom: 0 }}
                    >
                        <Select
                            placeholder="Selecciona un empleado"
                            showSearch
                            optionFilterProp="children"
                            onChange={onChangeEmpleado}
                            disabled={disabledForm}
                        >
                            {
                                empleados.map((item) =>
                                    <Option key={item.value} value={item.value}>
                                        {item.text}
                                    </Option>
                                )
                            }
                        </Select>
                    </Form.Item>
                    <Button
                        type="primary"
                        icon={<ReloadOutlined />}
                        onClick={handleRecalcular}
                        loading={recalculando}
                        disabled={!empleadoSelected || disabledForm}
                    >
                        Actualizar Checadas
                    </Button>
                </Space>
            </Form>

            <Divider />

            {/* HEADER DE TOTALES */}
            {items.length > 0 && (
                <>
                    <Card
                        title="Resumen del Periodo"
                        style={{ marginBottom: 16 }}
                        size="small"
                    >
                        <Row gutter={16}>
                            <Col span={4}>
                                <Statistic
                                    title="Días Trabajados"
                                    value={totales.diasTrabajados}
                                    valueStyle={{ color: '#3f8600' }}
                                />
                            </Col>
                            <Col span={4}>
                                <Statistic
                                    title="Horas Trabajadas"
                                    value={totales.horasTrabajadas.toFixed(2)}
                                    valueStyle={{ color: '#1890ff' }}
                                />
                            </Col>
                            <Col span={4}>
                                <Statistic
                                    title="Horas Extras"
                                    value={totales.horasExtras.toFixed(2)}
                                    valueStyle={{ color: '#fa8c16' }}
                                />
                            </Col>
                            <Col span={4}>
                                <Statistic
                                    title="Descanso"
                                    value={totales.descanso.toFixed(2)}
                                    valueStyle={{ color: '#722ed1' }}
                                />
                            </Col>
                            <Col span={4}>
                                <Statistic
                                    title="Festivos"
                                    value={totales.festivos.toFixed(2)}
                                    valueStyle={{ color: '#eb2f96' }}
                                />
                            </Col>
                            <Col span={4}>
                                <Statistic
                                    title="Autorizadas"
                                    value={totales.autorizadas.toFixed(2)}
                                    valueStyle={{ color: '#52c41a' }}
                                />
                            </Col>
                        </Row>
                    </Card>
                </>
            )}
        </>

        {
            loading ? (
                <Skeleton loading={loading} active />
            ) : (
                <>
                    {
                        items.length === 0 ? (
                            <Empty description="Selecciona un periodo y un empleado para ver los datos" />
                        ) : (
                            <FormBody
                                items={items}
                                setItems={setItems}
                                columns={columns}
                            />
                        )
                    }
                </>
            )
        }
    </PageApp>
}

export default ChequeoEntradasPage;